










import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";

import "./baseInputNumber.css";
import BaseApi from "@/core/HttpResources/BaseApi";
import { AxiosResponse } from "axios";

@Component({})
export default class BaseInputNumber extends Vue {
  @Prop() public label!: string;
  @Prop() public value!: any;
  @Prop() public size!: string;
  @Prop() public maxLength!: string;
  @Prop() public maxNumber!: number;
  @Prop() public minNumber!: number;
  innerValue: number = 0;

  @Watch("value")
  onInput(value: any) {
    
    if (value && !isNaN(value)) {
        if (value >= this.minNumber && value <= this.maxNumber) {
            this.innerValue = value;
        } else if (value > this.maxNumber) {
            this.innerValue = this.maxNumber;
            this.$emit('setValue', this.maxNumber);
        } else {
            this.innerValue = this.minNumber;
            this.$emit('setValue', this.minNumber);
        }
    } else {
        
        this.$emit('setValue', 0);
    }
  }
}
